/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Column } from "app/partials/entity/Table";
import PageWrapper from "app/partials/entity/PageWrapper";
import { emptyMean, Mean } from 'app/modules/tp/means/_models';
import meanApi from 'app/modules/tp/means/_requests';
import MeanFormBuilder from 'app/modules/tp/means/builders/MeanFormBuilder';
import CheckboxSwitch from 'app/partials/form/CheckboxSwitch';

const columns: Array<Column<Mean>> = [
    {
        key: "provider",
        label: "Fornitore",
        render: (mean: Mean) => (<>{`${mean?.provider?.name?? ""} ${mean?.provider?.surname ?? ""}`}</>),
    },
    {
        key: "license_plate",
        label: "Targa",
        filterable: true,
        sortable: true,
        render: (mean: Mean) => (<>{mean.code ?? "" } {mean.license_plate}</>),
    },
    {
        key: "seats",
        label: "N. di Posti",
        filterable: true,
        sortable: true,
    },
    {
        key: "emission_class",
        label: "Classe di Emissione",
        filterable: true,
        sortable: true,
    },
    {
        key: "brand",
        label: "Marca",
        filterable: true,
        sortable: true,
    },
    {
        key: "model",
        label: "Modello",
        filterable: true,
        sortable: true,
    },
    //{
    //    key: "available",
    //    label: "Disponibilità",
    //    filterable: true,
    //    sortable: true,
    //    render: (mean: Mean) => (<CheckboxSwitch name={`${mean.id}`} checked={mean.available as boolean} readOnly />)
    //}
]


const entityIcon = "fa-solid fa-bus";

const MeansPage: FC = () => {
    return (
        <PageWrapper
            columns={columns}
            emptyEntity={emptyMean}
            entityIcon={entityIcon}
            entityApi={meanApi}
            labels={{
                icon: entityIcon,
                singleEntityName: "Mezzo",
                pluralEntityName: "Mezzi",
            }}
            form={MeanFormBuilder()}
        />
    );
}


export { MeansPage }
